import { useEffect, useState } from "react";
import * as bie from "react-bootstrap";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import PreviewandPrint from "./PreviewandPrint";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import ScrutinyReportExtensionPermission from "./ScrutinyReportExtensionPermission";
import { FaCheck, FaEye, FaFilter, FaList, FaMinus, FaTimes } from "react-icons/fa";
import ShiftingScrutinyReport from "./UniversityScreens/ShiftingScrutinyReport";
import ScrutinyReportForNewAc from "./UniversityScreens/ScrutinyReportForNewAc";
import NewCollegeApplPreview from "./NewCollegeApplPreview";
import ChangeOfManagement from "./UniversityScreens/ChangeOfManagement";
import { Field, Form, FormikProvider, useFormik } from "formik";

export default function ScrutinyReport() {
  // **********college name get api********
  const [scrutinyData, setScrutinyData] = useState([]);
  const [collCode, setCollCode] = useState("");
  const [instName, setInstName] = useState("");
  const [displayType, setDisplayType] = useState("mainReport");
  const [nocType, setNocType] = useState("");
  const [nocTypefromTable, setNocTypefromTable] = useState("eop");
  const [filteredData, setFilteredData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");

  // function GetScrutinyData(nocType) {
  //   let url = config?.url?.FAC_URL + "getInspReport/" + nocType;
  //   CommonAxiosGet(url).then((res) => {
  //     if (res?.data?.scode === "01") {
  //       setScrutinyData(res?.data?.data);
  //     } else {
  //       setScrutinyData([]);
  //     }
  //   });
  // }
  // useEffect(() => {
  //   GetScrutinyData();
  // }, []);
  const formik = useFormik({
    initialValues: {
      nocType: "eop",
    },
    onSubmit: () => { },
  });

  // function GetScrutinyData(type) {
  //   let url = config?.url?.FAC_URL + "getInspReport/" + type;

  //   CommonAxiosGet(url).then((res) => {
  //     if (res?.data?.scode === "01") {
  //       setScrutinyData(res?.data?.data);
  //     } else {
  //       setScrutinyData([]);
  //     }
  //   });
  // }
  function GetScrutinyData(type) {
    let url = config?.url?.FAC_URL + "getInspReport/" + type;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        const data = res?.data?.data || [];
        setScrutinyData(data);
        const filtered = applyFilter(data, statusFilter, type);
        setFilteredData(filtered);
      } else {
        setScrutinyData([]);
        setFilteredData([]);
      }
    });
  }
  useEffect(() => {
    GetScrutinyData(formik.values.nocType);
  }, [formik.values.nocType]);
  useEffect(() => {
    const filtered = applyFilter(scrutinyData, statusFilter, formik.values.nocType);
    setFilteredData(filtered);
  }, [statusFilter, scrutinyData, formik.values.nocType]);
  //  const previewBtn = {
  //         ...iconBtn,
  //         backgroundColor: "#e0f2fe",
  //         color: "#0284c7",
  //     };
  // Table columns
  const scrutinyColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "ub_name",
      header: "University Name",
      accessorKey: "ub_name",
      Footer: "",
    },
    {
      id: "inst_name",
      header: "College Name-Code",
      accessorKey: "inst_name",
      Footer: "",
    },
    {
      id: "preview",
      header: "College Preview",
      cell: ({ row }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm px-2 py-1"
              title="Preview College"
              onClick={() => {
                const code = row.original.inst_name.split("-")[1].trim();
                setCollCode(code);
                setNocType(row.original.noc_type);
                setDisplayType("preview");
              }}
            >
              <FaEye size={15} />
            </button>
          </div>
        );
      },
    },
    {
      id: "noc_type",
      header: "NOC Type",
      accessorKey: "noc_type",
      Footer: "",
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                const code = row.original.inst_name.split("-")[1].trim();
                const instName = row.original.inst_name;
                setDisplayType("srutinyReport");
                setCollCode(code);
                setNocType(row.original.noc_type);
                setInstName(instName);
              }}
            >
              {row.original.noc_type === "eop"
                ? "EOP Inspection"
                : row.original.noc_type === "shifting"
                  ? "Shifting Inspection"
                  : row.original.noc_type === "new_college"
                    ? "New College"
                    : row.original.noc_type === "management"
                      ? "Management Scrutiny Form"
                      : ""}
            </button>
          </div>
        );
      },
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "",
      cell: ({ row }) => {
        const nocType = row.original.noc_type;
        let statusValue = "";

        // Get the status based on noc_type
        if (nocType === "eop") {
          statusValue = row.original.eop_status;
        } else if (nocType === "shifting") {
          statusValue = row.original.shifting_status;
        } else if (nocType === "management") {
          statusValue = row.original.management_status;
        }

        // Determine display text and color
        let displayText = "";
        let colorCode = "";
        let icon = null;

        if (statusValue === "eop_done" || statusValue === "shifting_done" || statusValue === "management_done") {
          displayText = "Already Submitted";
          colorCode = "#15803d";
          icon = <FaCheck />;
        } else if (statusValue === "eop_not_done" || statusValue === "shifting_not_done" || statusValue === "management_not_done") {
          displayText = "Not Submitted";
          colorCode = "#dc2626";
          icon = <FaTimes />;
        } else {
          displayText = "N/A";
          colorCode = "#6b7280";
          icon = <FaMinus />;
        }

        return (
          <span style={{ color: colorCode, fontSize: "13px", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: "4px", }} >
            {icon} {displayText}
          </span>
        );
      },
      Footer: "",
    },
  ];
  // Function to get status value based on nocType
  const getStatusValue = (row, type) => {
    if (type === "eop") {
      return row.eop_status;
    } else if (type === "shifting") {
      return row.shifting_status;
    } else if (type === "management") {
      return row.management_status;
    } else if (type === "new_college") {
      return row.new_college_status;
    }
    return "";
  };

  // Function to check if a row is submitted
  const isSubmitted = (row, type) => {
    const status = getStatusValue(row, type);
    return status === `${type}_done`;
  };

  // Function to check if a row is not submitted
  const isNotSubmitted = (row, type) => {
    const status = getStatusValue(row, type);
    return status === `${type}_not_done`;
  };

  // Apply filter based on selected status
  const applyFilter = (data, filterType, currentNocType) => {
    if (filterType === "all") {
      return data;
    } else if (filterType === "submitted") {
      return data.filter(row => isSubmitted(row, currentNocType));
    } else if (filterType === "notSubmitted") {
      return data.filter(row => isNotSubmitted(row, currentNocType));
    }
    return data;
  };

  // Get getCounts for badges
  const getCounts = () => {
    const total = scrutinyData.length;
    const submitted = scrutinyData.filter(row => isSubmitted(row, formik.values.nocType)).length;
    const notSubmitted = scrutinyData.filter(row => isNotSubmitted(row, formik.values.nocType)).length;
    return { total, submitted, notSubmitted };
  };
  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <bie.Row className="px-2 pt-3 mb-3 w-100">
          {displayType === "mainReport" ? (
            <>
              <FormikProvider value={formik}>
                <Form>
                  <bie.Row>
                    <bie.Col lg={2}>
                      <label
                        className="form-label mb-0"
                        style={{
                          color: "#0f766e",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Select NOC Type
                      </label>
                    </bie.Col>

                    <bie.Col lg={3}>
                      <select
                        name="nocType"
                        className="form-control"
                        value={formik.values.nocType}
                        onChange={(e) => {
                          formik.handleChange(e);
                          setStatusFilter("all");
                        }}
                      >
                        <option value="eop">EOP</option>
                        <option value="new_college">New College</option>
                        <option value="management">Management Change</option>
                        <option value="shifting">Shifting</option>
                      </select>
                    </bie.Col>
                  </bie.Row>
                  <pre />
                  {/* Filter Buttons */}
                  <bie.Row className="mb-3">
                    <bie.Col>
                      <div className="d-flex gap-3 align-items-center">
                        <span className="fw-bold me-2">
                          <FaFilter className="me-1" /> Filter by Status:
                        </span>

                        <button
                          type="button"
                          className={`btn btn-sm ${statusFilter === "all" ? "btn-outline-primary" : "btn-outline-secondary"}`}
                          onClick={() => setStatusFilter("all")}
                        >
                          <FaList className="me-1" />All <span className="badge bg-light text-dark ms-1">{getCounts.total}</span>
                        </button>

                        <button
                          type="button"
                          className={`btn btn-sm ${statusFilter === "submitted" ? "btn-success" : "btn-outline-success"}`}
                          onClick={() => setStatusFilter("submitted")}
                        >
                          <FaCheck className="me-1" /> Already Submitted
                          <span className="badge bg-light text-dark ms-1">{getCounts.submitted}</span>
                        </button>

                        <button
                          type="button"
                          className={`btn btn-sm ${statusFilter === "notSubmitted" ? "btn-danger" : "btn-outline-danger"}`}
                          onClick={() => setStatusFilter("notSubmitted")}
                        >
                          <FaTimes className="me-1" /> Not Submitted
                          <span className="badge bg-light text-dark ms-1">{getCounts.notSubmitted}</span>
                        </button>
                      </div>
                    </bie.Col>
                  </bie.Row>
                </Form>
              </FormikProvider>
              {/* // <div className="all-table-content table-responsive"> */}
              {/* <div className="overal-stathead">
                <span>EOP Scrutiny</span>
              </div> */}



              {scrutinyData.length > 0 ? (
                <div className="table-responsive">
                  <CommonReactTable
                    // data={scrutinyData}
                    data={filteredData}
                    columns={scrutinyColumns}
                    filename="Scrutiny_Report"
                    headerName="Scrutiny Report"
                    showPagination={false}
                    showPrint={false}
                    showExcel={true}
                    excelFileName="Scrutiny_Report"
                    showFooter={false}
                  />
                </div>
              ) : (
                <center className="text-danger mt-4 h5">***** No Data Found *****</center>
              )}
            </>
          ) : //  </div>
            displayType === "preview" ? (
              <>
                <div className="text-end">
                  <button className="btn btn-secondary" onClick={() => setDisplayType("mainReport")}>
                    Back
                  </button>
                </div>
                {nocType === "new_college" ? <NewCollegeApplPreview collCode={collCode} showHeader={true} /> : <PreviewandPrint collCode={collCode} nocType={nocType} />}
              </>
            ) : displayType === "srutinyReport" ? (
              <>
                <div className="text-end">
                  <button className="btn btn-secondary" onClick={() => setDisplayType("mainReport")}>
                    Back
                  </button>
                </div>
                {nocType === "eop" ? (
                  <ScrutinyReportExtensionPermission collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "shifting" ? (
                  <ShiftingScrutinyReport collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "new_college" ? (
                  <ScrutinyReportForNewAc collCode={collCode} nocType={nocType} instName={instName} />
                ) : nocType === "management" ? (
                  <ChangeOfManagement collCode={collCode} nocType={nocType} instName={instName} />
                ) : null}
              </>
            ) : (
              <></>
            )}
        </bie.Row>
      </bie.Container>
    </>
  );
}





// import { useState, useCallback, useEffect } from "react";
// import * as bie from "react-bootstrap";
// import { FormikProvider, useFormik, Form } from "formik";
// import { FaCheck, FaEye, FaMinus, FaTimes } from "react-icons/fa";

// import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
// import { config } from "../CommonUtils/CommonURLS";
// import CommonReactTable from "../CommonUtils/CommonReactTable";

// import PreviewandPrint from "./PreviewandPrint";
// // import ScrutinyReportExtensionPermission from "./UniversityScreens/ScrutinyReportExtensionPermission";
// import ScrutinyReportForNewAc from "./UniversityScreens/ScrutinyReportForNewAc";
// import NewCollegeApplPreview from "./NewCollegeApplPreview";
// import ChangeOfManagement from "./UniversityScreens/ChangeOfManagement";
// import ShiftingScrutinyReport from "./UniversityScreens/ShiftingScrutinyReport";
// import { getInstCode, getActionLabel, getStatusMeta, getStatus } from "./Inspections/scrutinyHelpers";



// import ScrutinyReportExtensionPermission from "./ScrutinyReportExtensionPermission";

// export default function ScrutinyReport() {
//   const [scrutinyData, setScrutinyData] = useState([]);
//   const [collCode, setCollCode] = useState("");
//   const [instName, setInstName] = useState("");
//   const [displayType, setDisplayType] = useState("mainReport");
//   const [nocType, setNocType] = useState("eop");

//   const formik = useFormik({
//     initialValues: { nocType: "eop" },
//     onSubmit: () => { },
//   });

//   // API
//   const GetScrutinyData = useCallback((type) => {
//     const url = config?.url?.FAC_URL + "getInspReport/" + type;

//     CommonAxiosGet(url).then((res) => {
//       setScrutinyData(res?.data?.scode === "01" ? res.data.data : []);
//     });
//   }, []);

//   useEffect(() => {
//     GetScrutinyData(formik.values.nocType);
//   }, [formik.values.nocType, GetScrutinyData]);

//   // Handlers
//   const handlePreview = useCallback((row) => {
//     setCollCode(getInstCode(row.inst_name));
//     setNocType(row.noc_type);
//     setDisplayType("preview");
//   }, []);

//   const handleAction = useCallback((row) => {
//     setCollCode(getInstCode(row.inst_name));
//     setInstName(row.inst_name);
//     setNocType(row.noc_type);
//     setDisplayType("srutinyReport");
//   }, []);

//   // Columns
//   const scrutinyColumns = [
//     {
//       id: "slNo",
//       header: "Sl.No",
//       cell: ({ row }) => row.index + 1,
//     },
//     {
//       id: "ub_name",
//       header: "University Name",
//       accessorKey: "ub_name",
//     },
//     {
//       id: "inst_name",
//       header: "College Name-Code",
//       accessorKey: "inst_name",
//     },
//     {
//       id: "preview",
//       header: "College Preview",
//       cell: ({ row }) => (
//         <button
//           className="btn btn-outline-primary btn-sm"
//           onClick={() => handlePreview(row.original)}
//         >
//           <FaEye />
//         </button>
//       ),
//     },
//     {
//       id: "noc_type",
//       header: "NOC Type",
//       accessorKey: "noc_type",
//     },
//     {
//       id: "action",
//       header: "Action",
//       cell: ({ row }) => (
//         <button
//           className="btn btn-secondary btn-sm"
//           onClick={() => handleAction(row.original)}
//         >
//           {getActionLabel(row.original.noc_type)}
//         </button>
//       ),
//     },
//     {
//       id: "status",
//       header: "Status",
//       cell: ({ row }) => {
//         const nocType = row.original.noc_type;
//         const statusValue = getStatus(row.original, nocType);
//         const meta = getStatusMeta(statusValue);

//         const iconMap = {
//           check: <FaCheck />,
//           times: <FaTimes />,
//           minus: <FaMinus />,
//         };

//         return (
//           <span style={{ color: meta.color, fontWeight: 600 }}>
//             {iconMap[meta.icon]} {meta.text}
//           </span>
//         );
//       },
//     },
//   ];

//   return (
//     <bie.Container>
//       <bie.Row>
//         {displayType === "mainReport" && (
//           <>
//             <FormikProvider value={formik}>
//               <Form>
//                 <select
//                   name="nocType"
//                   value={formik.values.nocType}
//                   onChange={formik.handleChange}
//                   className="form-control"
//                 >
//                   <option value="eop">EOP</option>
//                   <option value="new_college">New College</option>
//                   <option value="management">Management</option>
//                   <option value="shifting">Shifting</option>
//                 </select>
//               </Form>
//             </FormikProvider>

//             {scrutinyData?.length > 0 ? (
//               <CommonReactTable
//                 data={scrutinyData}
//                 columns={scrutinyColumns}
//                 filename="Scrutiny_Report"
//                 headerName="Scrutiny Report"
//                 showPagination={false}
//                 showPrint={false}
//                 showExcel={true}
//                 excelFileName="Scrutiny_Report"
//                 showFooter={false}
//               />
//             ) : (
//               <center>No Data Found</center>
//             )}
//           </>
//         )}

//         {displayType === "preview" && (
//           <>
//             <button onClick={() => setDisplayType("mainReport")}>
//               Back
//             </button>

//             {nocType === "new_college" ? (
//               <NewCollegeApplPreview collCode={collCode} />
//             ) : (
//               <PreviewandPrint collCode={collCode} nocType={nocType} />
//             )}
//           </>
//         )}

//         {displayType === "srutinyReport" && (
//           <>
//             <button onClick={() => setDisplayType("mainReport")}>
//               Back
//             </button>

//             {nocType === "eop" && (
//               <ScrutinyReportExtensionPermission
//                 collCode={collCode}
//                 nocType={nocType}
//                 instName={instName}
//               />
//             )}

//             {nocType === "shifting" && (
//               <ShiftingScrutinyReport
//                 collCode={collCode}
//                 nocType={nocType}
//                 instName={instName}
//               />
//             )}

//             {nocType === "new_college" && (
//               <ScrutinyReportForNewAc
//                 collCode={collCode}
//                 nocType={nocType}
//                 instName={instName}
//               />
//             )}

//             {nocType === "management" && (
//               <ChangeOfManagement
//                 collCode={collCode}
//                 nocType={nocType}
//                 instName={instName}
//               />
//             )}
//           </>
//         )}
//       </bie.Row>
//     </bie.Container>
//   );
// }